<div
  class="min-h-screen flex flex-column justify-content-center align-items-center text-center gap-4"
  style="
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: #fff;
    margin: -8px;
  "
>
  <div class="flex flex-column align-items-center gap-3">
    <i class="pi pi-lock text-6xl"></i>
    <h1 class="text-5xl font-bold m-0">Access Denied</h1>
    <p class="text-lg m-0 opacity-90">
      Your account is inactive or does not have the necessary permissions. Please contact your admin for support.
    </p>
  </div>

  <button
    pButton
    pRipple
    type="button"
    (click)="logout()"
    label="Log Out"
    icon="pi pi-sign-out"
    class="p-button-rounded p-button-outlined text-white border-white mt-3"
  ></button>
</div>
